const rangeDateFilter = (rows: any[], id: number, filterValue: Date[]) => {
    console.log('Date searchfilter')
    return rows.filter(row => {
        const rowValue = new Date(row.original[id].props.children[0].props['data-filter'])
        return rowValue>=filterValue[0]&&rowValue<=filterValue[1]
    })
}
rangeDateFilter.autoRemove = (val: Boolean) => !val
export default rangeDateFilter